import React, { useEffect, useState } from "react";
import Cover from "./Cover";
import {
  Box,
  Button,
  CircularProgress,
  Container,
  Drawer,
  InputAdornment,
  MenuItem,
  TextField,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Country } from "country-state-city";

import PhoneInput from "react-phone-input-2";
import SearchIcon from "@material-ui/icons/Search";
import UpdateProfile from "./UpdateProfile";
import { getTimezonesForCountry } from 'countries-and-timezones';
import { appUrl } from "../../../../../../utils/config";
import axios from "axios";
import { validateProfileData } from "./validate";
const useStyles = makeStyles((theme) => ({
  drawerPaper: {
    width: "30vw",
  },
  heading: {
    marginTop: "2em",
  },
  textFieldWrapper: {
    marginBottom: theme.spacing(2),
  },
  buttonContainer: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    marginTop: "auto",
    marginBottom: theme.spacing(2),
    textTransform: "none",
  },
}));
export default function EditProfile({
  setEditProfile,
  user,
  departmentDetails,
  handleRefresh,
  setViewDetailsDrawer,
  selectedRole,
}) {
  const classes = useStyles();
  const [updateProfileDrawer, setUpdateProfileDrawer] = useState(false);
  const [roleOptions, setRoleOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [errors, setErrors] = useState({});
  const [isLocationEditable, setIsLocationEditable] = useState(false);
  const [locationOptions, setLocationOptions] = useState([]);
  const [reqObj, setReqObj] = useState({});
  const [profileData, setProfileData] = React.useState({
    full_name: user?.full_name || "",
    email_address: user?.email_address || "",
    phoneCode: user?.phone_number?.split(" ")[0] || "",
    phoneNumber: user?.phone_number?.split(" ")[1] || "",
    country: user?.country || "",
    location: user?.location || "",
    employee_number: user?.employee_number || "",
    // role: user ? `${user?.department_name} - ${user?.role_name}` : "",
    role:
      user?.department_name && user?.role_name
        ? `${user.department_name} - ${user.role_name}`
        : user?.department_name === null && user?.role_name === null
          ? "not found"
          : user?.department_name === null
            ? "null - " + user?.role_name
            : user?.role_name === null
              ? user?.department_name + " - null"
              : "", // Handles all null scenarios

    department_id: user?.department_id || null,
    collaborator_role_id: user?.collaborator_role_id || null,
  });

  // console.log("user",user);
  //   console.log("profiledata",profileData)

  const getRoleOptions = () => {
    if (!departmentDetails || departmentDetails.length === 0) return [];
    let options = [];
    departmentDetails.forEach((department) => {
      department.rolesList.forEach((role) => {
        options.push({
          displayName: `${department.departmentName} - ${role.role_name}`,
          departmentID: department.departmentID,
          collaborator_role_id: role.collaborator_role_id,
        });
      });
    });
    return options;
  };

useEffect(() => {
  if (profileData.country && profileData.location) {
    const isoCode = countryCodeMap[profileData.country];
    const timezonesObj = getTimezonesForCountry(isoCode);
    const timezones = timezonesObj
      ? Object.values(timezonesObj).map((tz) => tz.name)
      : [];

    setLocationOptions(timezones);
    setIsLocationEditable(timezones.length > 0);
  }
}, [profileData.country, profileData.location]);

  useEffect(() => {
    const options = getRoleOptions();
    setRoleOptions(options);
    // if (!options.find((opt) => opt.displayName === profileData.role)) {
    if (profileData.role === "" && options.length > 0) {
      setProfileData((prev) => ({
        ...prev,
        role: options.length > 0 ? options[0].displayName : "",
        department_id: options.length > 0 ? options[0].departmentID : null,
        collaborator_role_id:
          options.length > 0 ? options[0].collaborator_role_id : null,
      }));
    }
  }, [departmentDetails, user]);

  const handleRoleChange = (event) => {
    const selectedOption = roleOptions.find(
      (option) => option.displayName === event.target.value
    );

    setProfileData((prev) => ({
      ...prev,
      role: event.target.value,
      department_id: selectedOption?.departmentID || null,
      collaborator_role_id: selectedOption?.collaborator_role_id || null,
    }));
  };
  // const fetchAllCountries = () => {
  //   const countries = Country.getAllCountries();
  //   // console.log("🚀 ~ fetchAllCountries ~ countries:", countries);

  //   return countries?.map((country) => (
  //     <MenuItem key={country?.isoCode} value={country?.name}>
  //       {country?.name}
  //     </MenuItem>
  //   ));
  // };

  const allCountries = Country.getAllCountries();

  const countryCodeMap = allCountries.reduce((acc, country) => {
    acc[country.name] = country.isoCode;
    return acc;
  }, {});

  const fetchAllCountries = () => {
    return allCountries.map((country) => (
      <MenuItem key={country.isoCode} value={country.name}>
        {country.name}
      </MenuItem>
    ));
  };

  // const handleChange = (e) => {
  //   if (e && e.target) {
  //     setProfileData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  //   }
  // };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "country") {
      const isoCode = countryCodeMap[value];
      const timezonesObj = getTimezonesForCountry(isoCode);

      const timezones = timezonesObj
        ? Object.values(timezonesObj).map((tz) => tz.name)
        : [];

      setLocationOptions(timezones);
      setIsLocationEditable(timezones.length > 0);

      setProfileData((prev) => ({
        ...prev,
        country: value,
        location: timezones.length === 1 ? timezones[0] : "",
      }));
    } else {
      setProfileData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handlePhoneChange = (phone, country) => {
    // phone contains the full number like "911234567890"
    // country.dialCode contains the country code like "91"
    const dialCode = country?.dialCode || "";
    const numberWithoutCode = phone.slice(dialCode.length);
    
    setProfileData((prev) => ({ 
      ...prev, 
      phoneCode: `+${phone.slice(0, dialCode.length)}`, // Store as "+91"
      phoneNumber: numberWithoutCode // Store as "1234567890"
    }));
  };

  const updateProfile = () => {
    const validationErrors = validateProfileData(profileData);
    // console.log("🚀 ~ updateProfile ~ validationErrors:", validationErrors);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setErrors({});

    let updatedFields = {};
    
    // Normalize phone_number for comparison
    const formatPhoneNumber = (phoneNumber) => {
      return phoneNumber.startsWith('+') ? phoneNumber : `+${phoneNumber}`;
    };

    // Normalize phone numbers by removing spaces and ensuring + prefix for accurate comparison
    const normalizePhone = (phone) => {
      if (!phone || phone === "null" || phone.trim() === "") return "";
      // Remove all spaces and ensure it starts with +
      let normalized = phone.replace(/\s+/g, "");
      if (!normalized.startsWith('+')) {
        normalized = `+${normalized}`;
      }
      return normalized;
    };

    const originalPhoneNormalized = normalizePhone(user?.phone_number || "");
    const currentPhoneRaw = `${profileData.phoneCode || ""} ${profileData.phoneNumber || ""}`;
    const currentPhoneNormalized = normalizePhone(currentPhoneRaw);

    // console.log("Phone Comparison:", {
    //   original: user?.phone_number,
    //   originalNormalized: originalPhoneNormalized,
    //   currentRaw: currentPhoneRaw,
    //   currentNormalized: currentPhoneNormalized,
    //   areEqual: currentPhoneNormalized === originalPhoneNormalized
    // });

    // Compare each field, ensuring undefined/null are treated as ""
    Object.keys(profileData).forEach((key) => {
      const originalValue = user[key] ?? ""; // Normalize undefined/null to ""
      const currentValue = profileData[key] ?? "";

      if (key === "phoneCode" || key === "phoneNumber") {
        // Only add phone_number if both parts are valid and the number has actually changed
        const hasValidPhone = profileData.phoneCode && profileData.phoneNumber && 
                             profileData.phoneCode.trim() !== '' && 
                             profileData.phoneNumber.trim() !== '' &&
                             profileData.phoneCode !== 'null' && 
                             profileData.phoneNumber !== 'null';
        
        // Compare normalized phone numbers to avoid false positives
        if (hasValidPhone && currentPhoneNormalized !== originalPhoneNormalized && currentPhoneNormalized !== "") {
          updatedFields["phone_number"] = formatPhoneNumber(currentPhoneRaw);
        }
      } else if (key === "role") {
        // Special handling for role, department_id, and collaborator_role_id
        const originalRoleDisplay =
          user?.department_name && user?.role_name
            ? `${user.department_name} - ${user.role_name}`
            : user?.department_name === null && user?.role_name === null
              ? "not found"
              : user?.department_name === null
                ? "null - " + user?.role_name
                : user?.role_name === null
                  ? user?.department_name + " - null"
                  : "";

        if (
          profileData.role !== originalRoleDisplay ||
          profileData.department_id !== user?.department_id ||
          profileData.collaborator_role_id !== user?.collaborator_role_id
        ) {
          // updatedFields.role = profileData.role;
          updatedFields.department_id = profileData.department_id;
          updatedFields.collaborator_role_id = profileData.collaborator_role_id;

          if (profileData.role && profileData.role.includes(" - ")) {
            const [departmentName, roleName] = profileData.role.split(" - ");
            updatedFields.department_name = departmentName === "null" ? null : departmentName;
            updatedFields.role_name = roleName === "null" ? null : roleName;
          } else {
            updatedFields.department_name = null;
            updatedFields.role_name = null;
          }
        }
      } else if (currentValue !== originalValue) {
        updatedFields[key] = currentValue;
      }
    });

    // Add saas_user_id by default
    updatedFields.saas_user_id = user?.saas_user_id;

    // console.log("Updated Fields (reqObj):", updatedFields);
    setReqObj(updatedFields);

    setUpdateProfileDrawer(true);
  };

  const displayLoading = (
    <div style={{ textAlign: "center", marginTop: "1.5em" }}>
      <CircularProgress color="primary" thickness={7} />
    </div>
  );
  const displayError = (
    <Box
      style={{
        border: "2px solid rgb(255,0,0)",
        backgroundColor: "rgb(255,240,240)",

        textAlign: "center",
        padding: "0.8rem",
        fontSize: "0.875rem",
        marginTop: "1.5em",
      }}
    >
      {" "}
      <Typography variant="body2">
        Something went wrong. Please try again later.
      </Typography>
    </Box>
  );

  if (loading) return displayLoading;
  if (error) return displayError;
  return (
    <Box
      style={{ minHeight: "100%", display: "flex", flexDirection: "column" }}
    >
      <Cover
        profilePic={user?.profile_pic}
        handleRefresh={handleRefresh}
        user={user}
        setViewDetailsDrawer={setViewDetailsDrawer}
      />
      <Container
        style={{ flexGrow: 1, display: "flex", flexDirection: "column" }}
      >
        <Typography variant="h6" className={classes.heading}>
          Edit Profile
        </Typography>
        <Box className={classes.textFieldWrapper}>
          <Typography style={{ fontSize: "14px", fontWeight: 500 }}>
            Full Name <span style={{ color: "red" }}>*</span>
          </Typography>
          <TextField
            placeholder="Full name"
            variant="outlined"
            size="small"
            required
            fullWidth
            value={profileData?.full_name}
            name="full_name"
            //onChange={handleChange}
            onChange={(e) => {
              const regex = /^[A-Za-z\s]*$/; // ✅ Allow only alphabets and spaces
              if (regex.test(e.target.value)) {
                handleChange(e); // ✅ Update state only if input is valid
              }
            }}
            onBlur={(e) => {
              const { name, value } = e.target;
              // Trim leading and trailing spaces for string values
              if (typeof value === "string" && value.trim() !== value) {
                const trimmedValue = value.trim();
                const syntheticEvent = {
                  target: {
                    name: name,
                    value: trimmedValue,
                  },
                };
                handleChange(syntheticEvent);
              }
            }}
            error={!!errors.name}
            helperText={errors.name}
          ></TextField>
        </Box>
        <Box className={classes.textFieldWrapper}>
          <Typography style={{ fontSize: "14px", fontWeight: 500 }}>
            Email <span style={{ color: "red" }}>*</span>
          </Typography>
          <TextField
            name="email_address"
            value={profileData?.email_address}
            placeholder="Email"
            onChange={handleChange}
            onBlur={(e) => {
              const { name, value } = e.target;
              // Trim leading and trailing spaces for string values
              if (typeof value === "string" && value.trim() !== value) {
                const trimmedValue = value.trim();
                const syntheticEvent = {
                  target: {
                    name: name,
                    value: trimmedValue,
                  },
                };
                handleChange(syntheticEvent);
              }
            }}
            variant="outlined"
            size="small"
            required
            fullWidth
            disabled //TODO: enable after email change implementation
            error={!!errors.email}
            helperText={errors.email}
          ></TextField>
        </Box>
        <Box className={classes.textFieldWrapper}>
          <Typography style={{ fontSize: "14px", fontWeight: 500 }}>
            Phone <span style={{ color: "red" }}></span>
          </Typography>
          <Box style={{ display: "flex", gap: "10px" }}>
            <PhoneInput
              country={""}
              value={profileData?.phoneCode}
              onChange={handlePhoneChange}
              enableSearch={true}
              inputStyle={{ width: "100%", minHeight: "40px" }}
              style={{
                flex: "0 0 30%",
                height: "40px",
              }}
              placeholder="Code"
              inputProps={{
                readOnly: true, // Disable direct input
              }}
            />

            <TextField
              name="phoneNumber"
              placeholder="Phone number"
              value={profileData?.phoneNumber}
              //onChange={handleChange}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, ""); // ✅ Remove non-numeric characters
                if (value.length <= 10) { // ✅ Restrict input to max 10 digits
                  setProfileData((prev) => ({ ...prev, phoneNumber: value }));
                }
              }}

              variant="outlined"
              size="small"
              required
              style={{ flexGrow: 1 }}
              error={!!errors.phone}
              helperText={errors.phone}
            ></TextField>
          </Box>
        </Box>

        <Box className={classes.textFieldWrapper}>
          <Typography style={{ fontSize: "14px", fontWeight: 500 }}>
            Country of Residence <span style={{ color: "red" }}>*</span>
          </Typography>
          <TextField
            name="country"
            onChange={handleChange}
            select
            variant="outlined"
            fullWidth
            required
            size="small"
            error={!!errors.country}
            helperText={errors.country}
            value={profileData?.country || ""}
            SelectProps={{
              displayEmpty: true,
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
          >
            {/* <MenuItem value="">Select Country</MenuItem> */}
            {fetchAllCountries()}
          </TextField>
        </Box>

        <Box className={classes.textFieldWrapper}>
          <Typography style={{ fontSize: "14px", fontWeight: 500 }}>
            Location (for time zone purpose)
          </Typography>
        <TextField
          name="location"
          onChange={handleChange}
          select
          fullWidth
          variant="outlined"
          size="small"
          value={profileData?.location}
          // disabled={!isLocationEditable}
          disabled={!isLocationEditable && !profileData.location}

        >
          {/* {locationOptions.length === 0 ? (
            <MenuItem value="">No Timezones</MenuItem>
          ) : (
            locationOptions.map((tz, index) => (
              <MenuItem key={index} value={tz}>
                {tz}
              </MenuItem>
            ))
          )} */}

          {!locationOptions.includes(profileData.location) && (
  <MenuItem value={profileData.location}>{profileData.location}</MenuItem>
)}
{locationOptions.map((tz, index) => (
  <MenuItem key={index} value={tz}>
    {tz}
  </MenuItem>
))}

        </TextField>
        
        </Box>

        <Box className={classes.textFieldWrapper}>
          <Typography style={{ fontSize: "14px", fontWeight: 500 }}>
            Employee Number <span style={{ color: "red" }}></span>
          </Typography>
          <TextField
            disabled
            name="employeeNumber"
            value={profileData?.employee_number}
            // onChange={handleChange}
            variant="outlined"
            size="small"
            required
            fullWidth
            // error={!!errors.employeeNumber}
            // helperText={errors.employeeNumber}
            placeholder="Employee number"
          ></TextField>
        </Box>

        <Box className={classes.textFieldWrapper}>
          <Typography style={{ fontSize: "14px", fontWeight: 500 }}>
            Department - Role <span style={{ color: "red" }}>*</span>
          </Typography>
          <TextField
            name="role"
            onChange={handleRoleChange}
            select
            variant="outlined"
            required
            fullWidth
            size="small"
            value={profileData?.role || ""}
            error={!!errors.role}
            helperText={errors.role}
            SelectProps={{
              displayEmpty: true,
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
          >
            {/* <MenuItem value={profileData.role}>{profileData.role}</MenuItem> */}
            {roleOptions && roleOptions.length > 0
              ? roleOptions.map((option) => (
                <MenuItem
                  key={option?.displayName}
                  value={option?.displayName}
                >
                  {option.displayName}
                </MenuItem>
              ))
              : null}
          </TextField>
        </Box>

        <Box className={classes.buttonContainer}>
          <Button
            size="small"
            variant="contained"
            disableElevation
            onClick={() => setEditProfile(false)}
            style={{ textTransform: "none" }}
          >
            Cancel
          </Button>

          <Button
            className={classes.btnPrimary}
            variant="contained"
            size="small"
            //   color="primary"
            style={{
              textTransform: "none",
              backgroundColor: "#286acf",
              color: "#fff",
            }}
            onClick={updateProfile}
          // onClick={() => {
          //   setUpdateProfileDrawer(true);
          // }}
          >
            Update Profile
          </Button>
        </Box>
      </Container>
      <Drawer
        anchor="right"
        open={updateProfileDrawer}
        onClose={() => setUpdateProfileDrawer(false)}
        classes={{ paper: classes.drawerPaper }}
        BackdropProps={{ style: { backgroundColor: "transparent" } }}
      >
        <UpdateProfile
          setUpdateProfileDrawer={setUpdateProfileDrawer}
          user={user}
          reqObj={reqObj}
          handleRefresh={handleRefresh}
          setViewDetailsDrawer={setViewDetailsDrawer}
          selectedRole={selectedRole}
        />
      </Drawer>
    </Box>
  );
}
